<template>
  <div id="footer">
    <div id="offerings">
      CAKES &nbsp;
      <span>&bull;</span> &nbsp; GIFTS &nbsp;
      <span>&bull;</span> &nbsp; CLASSES &nbsp;
      <span>&bull;</span> &nbsp; SPECIALTY SWEETS
    </div>
    <form class="pure-form" @change="trimData">
      <p>
        Don't Miss Out!
        <span>Join My VIP List To Get Updates &amp; Discounts!</span>
      </p>
      <input v-model="name" ref="nameInput" type="text" name="name" placeholder="Name" required>
      <input
        v-model="email"
        ref="emailInput"
        type="email"
        name="email"
        placeholder="Email"
        required
      >
      <button @click.prevent="join" type="submit" class="pure-button">
        <font-awesome-icon icon="envelope"/>&nbsp; Join
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      name: '',
      email: ''
    }
  },
  methods: {
    trimData() {
      this.name = this.name.trim()
      this.email = this.email.trim()
    },
    isValid() {
      return (
        this.$refs.nameInput.checkValidity() &&
        this.$refs.emailInput.checkValidity()
      )
    },
    clearData() {
      this.name = ''
      this.email = ''
    },
    addSubscriber() {
      this.$database.collection('subscribers').add({
        name: this.name,
        email: this.email
      })
    },
    join() {
      if (this.isValid()) {
        this.addSubscriber()
        this.clearData()
        alert('Thanks for signing up!')
      } else {
        alert('Please enter a name and email address.')
      }
    }
  }
}
</script>

<style lang="less" scoped>
#footer {
  background-color: rgba(41, 16, 101, 0.86);
  padding-bottom: 3em;
  text-align: center;

  #offerings {
    background-color: rgba(0, 0, 0, 0.11);
    line-height: 3em;
    color: rgba(255, 255, 255, 0.8);
    font-family: 'Open Sans Condensed', sans-serif;

    span {
      opacity: 0.2;
    }
  }

  p {
    color: white;
    font-family: 'Open Sans Condensed', sans-serif;
    font-size: 1.5em;

    span {
      display: block;
      font-size: 0.8em;
    }
  }

  input {
    margin: auto 0.25em;
  }

  button {
    background-color: #397884;
    color: white;
    font-family: 'Open Sans Condensed', sans-serif;
    margin: auto 0.25em;
  }
}

@media (max-width: 720px) {
  #footer {
    p {
      font-size: 1.2em;
    }

    input {
      clear: both;
      display: block;
      margin: 0.25em auto;
      width: 50%;
    }

    button {
      margin: 0.25em auto;
      width: 50%;
    }
  }
}

@media (max-width: 480px) {
  #footer {
    input {
      width: 80%;
      margin-left: 10%;
      margin-bottom: 0.5em;
    }

    button {
      width: 80%;
    }
  }
}
</style>
